export default __webpack_public_path__ + "static/media/FrameEverisColor.45c815c8.png";